import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { LoadingService } from '../services/loading.service';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private baseUrl = '/api';
  endpoint = 'file';

  constructor(public http: HttpClient, public loading: LoadingService) {}

  upload(file: File) {
    const MAX_FILE_SIZE_MB = 25;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

    if (file.size > MAX_FILE_SIZE_BYTES) {
      throw new Error(`Ukuran file melebihi batas ${MAX_FILE_SIZE_MB}MB.`);
    }

    const url = [this.baseUrl, this.endpoint, 'upload'].join('/');
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(url, formData, { observe: 'events' }).pipe(
      catchError((err) => {
        const message =
          err?.error?.message ??
          err?.error?.errors?.[0] ??
          err?.message ??
          'Gagal upload file';
        return throwError(() => new Error(message));
      }),
    );
  }

  download(id: any): Observable<Blob> {
    const url = [this.baseUrl, this.endpoint, 'download', id].join('/');
    return this.http
      .get(url, { responseType: 'blob', observe: 'response' })
      .pipe(
        switchMap((response) => {
          const blob = response.body;
          if (!blob) {
            return throwError(() => new Error('Gagal download file'));
          }

          const isErrorPayload =
            response.status >= 400 ||
            blob.type.includes('json') ||
            blob.type.includes('text/html');

          if (!isErrorPayload) {
            return from(Promise.resolve(blob));
          }

          return from(blob.text()).pipe(
            switchMap((text) => {
              let message = 'Gagal download file';
              try {
                const parsed = JSON.parse(text);
                message = parsed?.message ?? parsed?.error ?? message;
              } catch {
                if (text?.trim()) {
                  message = text.trim().slice(0, 200);
                }
              }
              return throwError(() => new Error(message));
            }),
          );
        }),
        catchError((err) => {
          if (err instanceof Error) {
            return throwError(() => err);
          }
          const message =
            err?.error?.message ??
            err?.message ??
            'Gagal download file';
          return throwError(() => new Error(message));
        }),
      );
  }
}
